export default "__VITE_ASSET__CteJrzt5__"